import { useCallback, useRef } from "react";

/**
 * Returns function and ref. Pass ref to desired component and call function to scroll to that component
 * @param offset - offset in pixels to scroll to. a negative value will be above the target
 */
export const useScrollIntoView = <T extends HTMLElement = HTMLElement>(offset = 0) => {
  const targetComponentRef = useRef<T | null>(null);

  const scrollToRef = useCallback(() => {
    if (!targetComponentRef.current) {
      return;
    }

    const elementPosition = targetComponentRef.current.getBoundingClientRect().top + window.scrollY;
    const offsetPosition = elementPosition + offset;
    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth",
    });
  }, [offset]);

  return [scrollToRef, targetComponentRef] as const;
};
